import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

import "./SkillItem.scss";

function SkillItem(props) {
	let barStyle = "bar-style" + (Math.floor(Math.random() * 10) + 1);
	//console.log(barStyle);

	return (
		<React.Fragment>
			<div className="skill-item">
				<ProgressBar
					className={barStyle}
					now={props.value}
					label={`${props.value}%`}
				/>
				<span>{props.skill}</span>
			</div>
		</React.Fragment>
	);
}

export default SkillItem;
